import { combineReducers } from "redux";
import { authReducer } from "./auth/authDuck";
import { commonReducer } from "./common/commonDuck";

const createRootReducer = (history) =>
  combineReducers({
    auth: authReducer,
    common: commonReducer,
  });

export default createRootReducer;
